// extracted by mini-css-extract-plugin
module.exports = {"root":"Home_root___sHk2","headerImage":"Home_headerImage__d5V8P"};